import styled from 'styled-components';
import { StyledButton } from './Button.styles';

export const BulkSaveButtonStyled = styled(StyledButton)`
  display: flex;
  align-items: center;
  gap: 8px;
`;
